export const styleResguardos = {
  color: "#d6336c",
  weight: 2,
};

export const styleDepartamentos = {
  color: "#0077b6",
  weight: 2,
  fillOpacity: 0.05,
};

export const styleMunicipios = {
  color: "#6610f2",
  weight: 1,
  fillOpacity: 0.15,
};

export const styleCampesina = {
  color: "#fd7e14",
  weight: 1,
  fillOpacity: 0.15,
};


export const styleConsejos = {
  color: "#0dcaf0",
  weight: 1,
  fillOpacity: 0.15,
};


export const styleSostenibilidad = {
  color: "#0d6efd",
  weight: 1,
  fillOpacity: 0.15,
};

export const styleVisitasPatti = {
  color: "#c90432",
  weight: 1,
  fillOpacity: 0.15,
};


export const styleGeoJSONNumeroVisita= {
  color: "#38A700",      // Color del borde
  weight: 2,             // Grosor del borde
  opacity: 1,            // Opacidad del borde
  fillOpacity: 0.2,      // Opacidad del relleno (solo para polígonos)
};



//Nuevas capas

export const styleconsejosComunitarios = {
  color: "#16a34a",
  weight: 1,
  fillOpacity: 0.15,
};

export const stylezonaReservaCampesinaConstituida= {
  color: "#f59e42",
  weight: 1,
  fillOpacity: 0.15,
};


export const  styleresguardoIndigenaFormalizado = {
  color: "#1d4ed8",
  weight: 1,
  fillOpacity: 0.15,
};

export const  stylereservaForestalNacional = {
  color: "#14532d",
  weight: 1,
  fillOpacity: 0.15,
};


export const stylerunap = {
  color: "#a21caf",
  weight: 1,
  fillOpacity: 0.15,
}


export const styledesagregacionRegional = {
  color: "#0ea5e9",
  weight: 1,
  fillOpacity: 0.15,
}



